import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  Approval,
  ContentApproval,
  DetailLeave,
  DetailReimburse,
  EditReimburse,
  DetailCashReceipt,
  DetailPersonalDataChange,
  DetailApprovalShiftSchedule,
} from "./pages";

const approvalRoutes = [
  {
    path: "/approval",
    element: (
      <ProtectedRoute name="approval">
        <Approval />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="approval"
        defaultTitle="approval.approval_title"
      />
    ),
    children: [
      {
        path: "/approval/waiting-approval",
        element: <ContentApproval type="waiting-approval" />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"approval.waiting_approval"} />
        ),
        children: [
          {
            path: "/approval/waiting-approval/leave/detail/:leaveId",
            element: <DetailLeave />,
            breadcrumb: null,
          },
          {
            path: "/approval/waiting-approval/reimbursement/edit/:reimbursementId",
            element: <EditReimburse />,
            breadcrumb: null,
          },
          {
            path: "/approval/waiting-approval/reimbursement/detail/:reimbursementId",
            element: <DetailReimburse />,
            breadcrumb: null,
          },
          {
            path: "/approval/waiting-approval/cash-receipt/detail/:cashReceiptId",
            element: <DetailCashReceipt />,
            breadcrumb: null,
          },
          {
            path: "/approval/waiting-approval/personal-data-change/detail/:personalDataChangeId",
            element: <DetailPersonalDataChange />,
            breadcrumb: null,
          },
          {
            path: "/approval/waiting-approval/shift-schedule/detail/:shiftScheduleId",
            element: <DetailApprovalShiftSchedule />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/approval/approved",
        element: <ContentApproval type="approved" />,
        breadcrumb: () => <TranslationBreadcrumb name={"approval.approved"} />,
        children: [
          {
            path: "/approval/approved/leave/detail/:leaveId",
            element: <DetailLeave />,
            breadcrumb: null,
          },
          {
            path: "/approval/approved/reimbursement/edit/:reimbursementId",
            element: <EditReimburse />,
            breadcrumb: null,
          },
          {
            path: "/approval/approved/reimbursement/detail/:reimbursementId",
            element: <DetailReimburse />,
            breadcrumb: null,
          },
          {
            path: "/approval/approved/cash-receipt/detail/:cashReceiptId",
            element: <DetailCashReceipt />,
            breadcrumb: null,
          },
          {
            path: "/approval/approved/personal-data-change/detail/:personalDataChangeId",
            element: <DetailPersonalDataChange />,
            breadcrumb: null,
          },
          {
            path: "/approval/approved/shift-schedule/detail/:shiftScheduleId",
            element: <DetailApprovalShiftSchedule />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/approval/rejected",
        element: <ContentApproval type="rejected" />,
        breadcrumb: () => <TranslationBreadcrumb name={"approval.rejected"} />,
        children: [
          {
            path: "/approval/rejected/leave/detail/:leaveId",
            element: <DetailLeave />,
            breadcrumb: null,
          },
          {
            path: "/approval/rejected/reimbursement/edit/:reimbursementId",
            element: <EditReimburse />,
            breadcrumb: null,
          },
          {
            path: "/approval/rejected/reimbursement/detail/:reimbursementId",
            element: <DetailReimburse />,
            breadcrumb: null,
          },
          {
            path: "/approval/rejected/cash-receipt/detail/:cashReceiptId",
            element: <DetailCashReceipt />,
            breadcrumb: null,
          },
          {
            path: "/approval/rejected/personal-data-change/detail/:personalDataChangeId",
            element: <DetailPersonalDataChange />,
            breadcrumb: null,
          },
          {
            path: "/approval/rejected/shift-schedule/detail/:shiftScheduleId",
            element: <DetailApprovalShiftSchedule />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
];

export default approvalRoutes;
